'use client';

import React, { useCallback } from 'react';
import { useTranslations } from 'next-intl';
import { PLCTA } from 'components/performance-lab/PLCTA';
import { PerformanceLabTFModal } from 'components/performance-lab/WaitlistTypeformModal';
import { useModal } from 'components/shared/Modal';
import { useLeaderboardHeroPaddingTop } from './useLeaderboardStickyTop';
import styles from './LeaderboardHero.module.css';

export const LeaderboardHero: React.FC = () => {
  const t = useTranslations('performance-lab');
  const modal = useModal();
  const paddingTop = useLeaderboardHeroPaddingTop();
  const title = t('leaderboard.title');

  const openBookTour = useCallback(() => {
    modal.set(
      <PerformanceLabTFModal planId="performance_lab_vo2_banner" />,
    );
    modal.setCloseButtonTheme('light');
    modal.show();
  }, [modal]);

  return (
    <section
      className={styles.heroSection}
      style={
        {
          ['--pt-mobile']: `${paddingTop.mobile}px`,
          ['--pt-desktop']: `${paddingTop.desktop}px`,
        } as React.CSSProperties
      }
    >
      <div className={styles.titleBlock}>
        <p className={styles.eyebrow}>
          {t('leaderboard.eyebrow')}
        </p>
        <h1 className={styles.title}>{title}</h1>
      </div>
      <div className={styles.heroMiddle}>
        <div className={styles.ctaBlock}>
          <p className={styles.ctaLead}>
            {t('leaderboard.hero.ctaLead')}
          </p>
          <PLCTA
            type="button"
            onClick={openBookTour}
            aria-label={t('leaderboard.bookTourCtaAria')}
            data-buttontype="vo2_leaderboard_hero_book_tour"
          >
            {t('leaderboard.bookTourCta')}
          </PLCTA>
        </div>
      </div>
    </section>
  );
};
